import React from 'react';
import DOMPurify from 'dompurify';
import { shallowEqual, useSelector } from 'react-redux';
import moment from 'moment';
import type { RootState } from '@/rootReducer';
import './EmailsItem.scss';

const EmailsItem = ({ email, replyButton }): JSX.Element => {
	const [user] = useSelector(
		(state: RootState) => [state.user.getIn(['authorize', 'user']).toJS()],
		shallowEqual
	);

	const createMarkup = (html: string) => {
		return { __html: html };
	};

	const colorCorrection = (emailBody: any) => {
		const matchReplace = emailText => {
			const regexMatch = new RegExp(
				/(?:#|0x)(?:[a-f0-9]{3}|[a-f0-9]{6})\b|(?:rgb|hsl)a?\([^\)]*\)/,
				'igm'
			);

			emailText.replace(
				regexMatch,
				function (match, startPosition, fullText) {
					switch (match) {
						case 'rgb(0, 0, 0)':
							emailBody = emailBody.replace(match, '#FFFFFF');
							break;
						case '#000':
							emailBody = emailBody.replace(match, '#FFFFFF');
							break;
						case '#000000':
							emailBody = emailBody.replace(match, '#FFFFFF');
							break;
						case 'rgb(255, 255, 255)':
							emailBody = emailBody.replace(match, '');
							break;
						default:
							if (/^#[0-3].*/.test(String(match))) {
								emailBody = emailBody.replace(match, '#FFFFFF');
							}
					}
				}
			);
		};

		matchReplace(emailBody);
		return emailBody;
	};

	return (
		<li key={email?.date} className="emails-item">
			<div className="emails-item-header">
				{email?.subject}
				{replyButton}
			</div>
			<div className="emails-item-div">
				<span className="emails-item-sender">
					{email.from[0].email === user.email
						? 'You'
						: email?.forwardedName || email.from[0].name}
				</span>
				<span className="emails-item-date">
					{moment(email.date * 1000).format('h:mma MMM Do, YYYY')}
				</span>
			</div>
			<div className="emails-item-email">
				{email.from[0].email === user.email
					? ''
					: email.from[0].email || email?.forwardedFrom}
			</div>
			{email.folder && email.folder.bodyText ? (
				<div
					className="emails-item-message"
					dangerouslySetInnerHTML={createMarkup(
						colorCorrection(
							DOMPurify.sanitize(email.folder.bodyText)
						)
					)}
				/>
			) : (
				<div
					className="emails-item-message"
					dangerouslySetInnerHTML={createMarkup(
						colorCorrection(DOMPurify.sanitize(email.body))
					)}
				/>
			)}
		</li>
	);
};

export default EmailsItem;
